import axiosApi, { api } from '../../../helpers/api-helper';

export const apiGetCourtImages = async ({ deviceId, count = 20 }) => {
  return await axiosApi.get(`${api.DEVICE_INFO_API_ROOT_URL}/court-images?device_id=${deviceId}&count=${count}`);
};
